var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 40,
    height: 40,
    viewBox: "107.875 107.875 40 40",
    style: {
      overflow: "visible",
      enableBackground: "new 107.875 107.875 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M110.345,112.855c0-1.386,1.157-2.508,2.584-2.508h29.832c1.427,0,2.584,1.123,2.584,2.508v29.984 c0,1.386-1.153,2.508-2.584,2.508h-29.832c-1.427,0-2.584-1.122-2.584-2.508V112.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118.309,121.685c1.843,0,2.99-1.216,2.99-2.734c-0.035-1.551-1.147-2.729-2.955-2.729 c-1.809,0-2.99,1.178-2.99,2.729c0,1.518,1.147,2.734,2.921,2.734H118.309L118.309,121.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.956,139.648v-15.806h-5.286v15.806H120.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M123.88,139.648h5.29v-8.83c0-0.469,0.034-0.944,0.169-1.276c0.382-0.947,1.255-1.921,2.714-1.921 c1.914,0,2.677,1.452,2.677,3.575v8.455h5.286v-9.064c0-4.854-2.611-7.115-6.086-7.115c-2.852,0-4.102,1.583-4.798,2.664h0.033 v-2.293h-5.289C123.949,125.325,123.88,139.648,123.88,139.648L123.88,139.648z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6106446c1dfa87aeff6d282a852460ee.svg";
export { ForwardRef as ReactComponent };